function removeSearch(url) {
  return url.replace(/#.*/, "").replace(/\?.*/, "");
}
export {
  removeSearch
};
//# sourceMappingURL=removeSearch.js.map
